import { PropsWithChildren } from 'react';

import { Flex, useColorModeValue, rem } from '@vimeo/bokeh';
import { IBaseDomElementProps } from '@vimeo/core/types/dom';

export function IconCircle({ children, ...props }: PropsWithChildren<IBaseDomElementProps>) {
  return (
    <Flex
      background={useColorModeValue('slate.50', 'grayscale.800')}
      height={rem(56)}
      width={rem(56)}
      borderRadius={'50%'}
      textAlign={'center'}
      flexShrink={0}
      justifyContent={'center'}
      alignItems={'center'}
      {...props}
    >
      {children}
    </Flex>
  );
}
